var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98629 16.6124C9.61486 16.9106 9.61642 17.463 9.95855 17.7945C10.2855 18.1112 10.8022 18.1068 11.1608 17.8264C13.9772 15.6236 18.0218 15.6235 20.8383 17.8261C21.197 18.1067 21.714 18.1111 22.041 17.7942C22.3831 17.4628 22.3849 16.9106 22.0137 16.6122C18.5367 13.8167 13.4679 13.8168 9.98629 16.6124ZM15.0154 21.3445C14.5075 21.5487 14.5067 22.2005 14.8999 22.5814L15.1188 22.7935C15.6098 23.2691 16.3896 23.2691 16.8805 22.7935L17.0994 22.5814C17.4926 22.2005 17.4919 21.5487 16.9839 21.3445C16.6719 21.2191 16.3375 21.1545 15.9997 21.1545C15.6619 21.1545 15.3274 21.2191 15.0154 21.3445ZM12.4256 18.9788C12.0387 19.2569 12.0408 19.8117 12.3831 20.1432C12.7099 20.4598 13.2255 20.4515 13.6067 20.2031C14.3089 19.7455 15.141 19.496 15.9997 19.496C16.8581 19.496 17.69 19.7454 18.3922 20.2028C18.7737 20.4513 19.2896 20.4597 19.6167 20.1428C19.9588 19.8114 19.9614 19.2568 19.5747 18.9785C17.461 17.4567 14.5432 17.4569 12.4256 18.9788Z",
    fill: "#7100FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.72727L7.81817 9.1818L4.40908 11.9091V1L7.81817 3.72727L1 9.1818",
    stroke: "#110017",
    strokeWidth: 1.11643,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.e431f7572d3bc2527e068e3fdaa2bc7d.svg";
export { ForwardRef as ReactComponent };